<template>
  <AdmPanel title="往年报告值" expandable :expand="expand" @expanded="$emit('expanded',$event)">
    <FilterBar class="filterbar" v-model="conditions" :condition="options.filter_rules">
      <iv-form-item>
        <iv-button type="info" :disabled="loader[REPORT_DATA]" @click="refreshReportData()">
          <iv-icon type="md-search" size="14" style="vertical-align: text-bottom" />
          搜索
        </iv-button>
      </iv-form-item>
    </FilterBar>

    <EmptyData
      v-if="!reportData"
      minHeight="100"
    />
    <iv-form
      v-else
      :ref="FORM_NAME"
      :model="reportData"
      label-position="top"
      :rules="validation.reportData">
      <iv-form-item :error="validation.form_item.value.text" prop="value">
        <div class="adm-flex-group" slot="label">
          <span class="ui-grow"> {{ `报告值（单位：${reportData.targetUnit}）` }}</span>
          <div class="adm-flex-group">
            <iv-dropdown
              v-rbac-allow.hidden="['carbonReport','edit']"
              @on-click="currencyExchange('元', $event)">
                <a href="javascript:void(0)">
                    汇率转换
                    <iv-icon type="md-arrow-dropdown"></iv-icon>
                </a>
                <iv-dropdownMenu slot="list">
                    <template v-for="item in options.currency">
                      <iv-DropdownItem :name="item.id" :key="item.id">{{ item.name }}</iv-DropdownItem>
                    </template>
                </iv-dropdownMenu>
            </iv-dropdown>
            <iv-dropdown style="margin-left: 15px;"
            v-rbac-allow.hidden="['carbonReport','edit']"
              @on-click="currencyExchange($event)">
                <a href="javascript:void(0)">
                    单位转换
                    <iv-icon type="md-arrow-dropdown"></iv-icon>
                </a>
                <iv-dropdownMenu slot="list">
                    <template v-for="item in options.units">
                      <iv-DropdownItem :name="item.id" :key="item.id">{{ item.name }}</iv-DropdownItem>
                    </template>
                </iv-dropdownMenu>
            </iv-dropdown>
          </div>
        </div>
        <iv-input
          :disabled="!$rbac.allow(['carbonReport', 'edit'], 'disable')"
          v-model="reportData.value"
          @on-change="
            () => {
              validation.form_item.value.text = null;
            }
          "
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 8 }"
          :loading="loader[CURRENCY_EXCHANGE]"
        ></iv-input>
      </iv-form-item>
      <div class="clearfix">
        <iv-button
          v-rbac-allow.hidden="['carbonReport','previousEdit']"
          type="primary"
          ghost
          class="pull-right"
          @click="saveDetail()"
          :loading="loader[REPORT_DATA]"
        >保存往年数据</iv-button>
      </div>
    </iv-form>
  </AdmPanel>
</template>
<script>
import api from "@/utils/api";
import contact from "@/utils/contact";
import { conditioner, carbon_years, getProductYear, BusinessError, RequestError } from "@/utils/";

import ModelMixin from "@/mixins/Model.mixin";
import LoaderMixin from "@/mixins/Loader.mixin";

import ReportModel from "@/models/ReportModel";
import ReportDataModel from "@/models/ReportDataModel";

import FilterBar from "@/components/FilterBar";
import EmptyData from "@/components/EmptyData.vue";

const TYPEFACE = "typeface";
const CURRENCY_EXCHANGE = "currency_exchange"
const YEAR_REPORT = "year";
const SOCIAL_REPORT = "social";
const REPORT = ReportModel.ModelName
const REPORT_DATA = ReportDataModel.ModelName
const FORM_NAME = `${REPORT_DATA}Form`;

const options = {
  unit: "",
  year: [],
}
const _conditioner = conditioner(
  {
    year: { type: Number, default: getProductYear()-1 },
  },
  {
    year: { type: Number, default: getProductYear()-1 },
  }
);

const filter_rules = [
  {
    name: "year",
    type: Array,
    options: carbon_years().filter(i=>i.id < getProductYear()),
    placeholder: "年份",
    style: { width: "70px" }
  }
];

export default {
  mixins: [
    LoaderMixin(REPORT,REPORT_DATA,TYPEFACE,CURRENCY_EXCHANGE),
    ModelMixin({
      contact,
      models: [ReportModel, ReportDataModel]
    })
  ],
  components: {
    FilterBar,
    EmptyData
  },
  props: {
    expand: {
      type: Boolean,
      defaults: false
    },
    stockCode: String,
    firstTargetNum: String,
    thirdTargetNum: String,
    type: {
      type: String,
      defaults: YEAR_REPORT
    },
    industryId: [Number,String],
    year: Number,
    searchTrigger: Number,
  },
  data(){
    return {
      REPORT,
      REPORT_DATA,
      TYPEFACE,
      CURRENCY_EXCHANGE,
      FORM_NAME,
      conditions: _conditioner.default(),
      options: {
        filter_rules,
        currency: [],
        units: [],
        ...options
      },
      reportData: null,
      validation: {
        reportData: ReportDataModel.validation(),
        form_item: {
          value: {
            show: false,
            text: ""
          }
        }
      },
    }
  },
  mounted() {
    this.syncYearFromProp()
    this.refreshCurrency()
    this.refreshUnits()
  },
  methods: {
    syncYearFromProp(){
      if (this.year) {
        this.conditions.year = this.year
      }
    },
    async refreshCurrency(){
      const result = await api.currencyList()
      if(!result && result.status < 300) return []
      this.options.currency = result.data.data.map(i=>({ ...i, id: i.currency, name: i.currencyName })) || []
    },
    async refreshUnits(){
      const result = await api.unitList()
      if(!result && result.status < 300) return []
      this.options.units = result.data.data.map(i=>({ ...i, id: i.unit, name: i.unitName })) || []
    },
    async refreshReportData(){
      if(!this.thirdTargetNum) return;
      //做特殊处理-往年数据从2024年开始
      if(this.conditions.year < 2024) {
        this.reportData = null
        return
      }
      const report_data_res = await this.$$fetch(REPORT_DATA, {
        type: this.type,
        year: this.conditions.year,
        stockCode: this.stockCode,
        industryId: this.industryId,
        // abbreviation: "",
        // complexForm: 0
      });
      if ([BusinessError, RequestError, Error].indexOf(report_data_res.constructor) == -1) {
        const thirdTargetNum = this.thirdTargetNum
        const [data] = report_data_res.data.filter(i=>i.thirdTargetNum==thirdTargetNum)
        this.reportData = data
      }
    },
    async currencyExchange(unit="元", currency="", year=this.conditions.year,value=this.reportData.value){
      this.$$loading(CURRENCY_EXCHANGE)
      const result = await api.currencyExchange(value, year, unit, currency)
      if(!result && result.status < 300) return this.$$loaded(CURRENCY_EXCHANGE)
      this.reportData.value = `${result.data.data.value}`
      this.$$loaded(CURRENCY_EXCHANGE)
    },
    async saveDetail(data=this.reportData) {
      this.$$loading(REPORT_DATA);
      const result = await this.$$active(REPORT_DATA, "previousEdit", {type:this.type,...data});

      if ([BusinessError, RequestError, Error].indexOf(result.constructor) == -1) {
        this.$$loaded(REPORT_DATA);
        //保存至本地并切换下一个指标

        this.$$success(
          `${data.year}的${data.secondTargetName}指标保存成功`
        );
      } else {
        console.error(result);
      }
      this.$$loaded(REPORT_DATA);
    },
  },
  watch:{
    searchTrigger(){
      this.syncYearFromProp()
      this.refreshReportData()
    },
    thirdTargetNum(){
      this.reportData = null
      this.refreshReportData()
    }
  }
}
</script>
